import { ArticleHeading4, Button, Responsive, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatsErrorPage.css';

type TChatsErrorPageProps = {
  onRetry: () => void;
};

export const ChatsErrorPage: React.VFC<TChatsErrorPageProps> = ({ onRetry }) => {
  return (
    <div className={styles['container']} data-testid="ChatsErrorPage">
      <Responsive desktop>
        <div className={styles['left']}>
          <ArticleHeading4>Сообщения</ArticleHeading4>
        </div>
      </Responsive>
      <div className={styles['right']}>
        <div className={styles['attention']} />
        <div className={styles['text']}>
          <ArticleHeading4>Что-то пошло не так</ArticleHeading4>
          <UIText1 color="gray60_100">Попробуйте зайти чуть позже</UIText1>
        </div>
        <Button onClick={onRetry}>Обновить</Button>
      </div>
    </div>
  );
};
